(function () {
  function setupInfiniteScrollingLogos(container) {
    const speed = Number(container.dataset.speed) || 50;
    const groups = container.querySelectorAll(".slideshow__slide-badges");

    groups.forEach((group) => {
      // Reset to originals only
      const originals = Array.from(
        group.querySelectorAll(".slideshow__slide-badge")
      );
      group.innerHTML = "";
      originals.forEach((el) => group.appendChild(el));

      // Get the exact width of original content
      const originalWidth = group.scrollWidth;

      // Clone the exact same content once to make it exactly 2x width
      originals.forEach((original) => {
        const clone = original.cloneNode(true);
        group.appendChild(clone);
      });

      // Now we have exactly 2x the original width
      // The -50% animation will work perfectly
      const finalWidth = group.scrollWidth;
      const duration = originalWidth / speed; // Use original width for timing

      group.style.animationDuration = duration + "s";
    });
  }

  function initAll() {
    document
      .querySelectorAll(".slideshow__slide-badges-container")
      .forEach((container) => setupInfiniteScrollingLogos(container));
  }

  document.addEventListener("DOMContentLoaded", initAll);
  window.addEventListener("load", initAll);
  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:block:select", initAll);
  document.addEventListener("shopify:block:deselect", initAll);
})();
